// Tested
export const isChromeVersion = (value: number): boolean => {
	const raw = window.navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
	return raw ? parseInt(raw[2], 10) === value : false;
};
